
@if (templatedTasks != null) {
  <mat-form-field>
    <mat-label>Templated Task</mat-label>
    <mat-select [(ngModel)]="selectedTask">
      <mat-option>
        <ngx-mat-select-search [formControl]="taskFilterCtrl"
          placeholderLabel="Find Task..."
        noEntriesFoundLabel="no matching task found"></ngx-mat-select-search>
      </mat-option>
      @for (templatedTask of filteredTasks | async; track templatedTask) {
        <mat-option [value]="templatedTask">{{templatedTask.name}}</mat-option>
      }
    </mat-select>
    <button mat-icon-button matSuffix [disabled]="selectedTask == null" (click)="redirect($event)">
      <mat-icon style="font-size: 20px">open_in_new</mat-icon>
    </button>
  </mat-form-field>
}
